import { useQueryClient } from "@tanstack/react-query";
import { qk } from "./queryKeys";
import { useCompaniesStore } from "../store/admin/companiesStore";

export type InvalidationDomain =
  | "vehicles"
  | "devices"
  | "trailers"
  | "drivers"
  | "users"
  | "shipments"
  | "quotes"
  | "costProfiles"
  | "finance";

const RELATED: Record<InvalidationDomain, readonly string[]> = {
  vehicles: ["vehicles", "devices", "trailers"],
  devices: ["devices", "vehicles"],
  trailers: ["trailers", "vehicles"],
  drivers: ["drivers", "availableDrivers", "availableUsers"],
  users: ["users", "drivers", "availableDrivers", "availableUsers"],
  shipments: ["shipments"],
  // Una cotización aceptada escribe price/estimated_cost en el viaje.
  quotes: ["quotes", "trips", "finance"],
  costProfiles: ["costProfiles"],
  finance: ["finance", "trips"],
};

export function useInvalidateDomain() {
  const queryClient = useQueryClient();
  const companyId = useCompaniesStore((s) => s.companyId);
  return (domain: InvalidationDomain) => {
    for (const key of RELATED[domain]) {
      queryClient.invalidateQueries({ queryKey: [key] });
    }
    queryClient.invalidateQueries({ queryKey: qk.counts(companyId) });
    queryClient.invalidateQueries({ queryKey: ["resellerCounts"] });
  };
}
